import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { styles } from '../../../utils/styles';
export const MeasuresTypePDF = ({
  measure
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width25
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, measure.displayalue && `${measure.displayalue}`));